export class DefaultMetric {
  uuid: string = undefined;
  name: string = undefined;
  priority = 1;
  props = new MetricProperty();
  dataProps = new MetricDataProperty();
}

export class MetricProperty {
  isHidden = true;
  type: MetricType = MetricType.REGULAR;
}

export class MetricDataProperty {
  sign: MetricSign = MetricSign.ANY;
  dataType: MetricDataType = MetricDataType.NUMBER;
  iconNameAndStylingLeft = 'plus-minus.svg';
}

export enum MetricType {
  STARTING = 'Starting',
  REGULAR = 'Regular',
  ENDING = 'Ending',
}

export enum MetricSign {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  ANY = 'Any sign',
}

export enum MetricDataType {
  STRING = 'String',
  NUMBER = 'Number',
  PERCENT = 'Percent',
  DATE = 'Date',
  DOCUMENT = 'Document'
}
